import {
  Breadcrumb,
  BreadcrumbItem as BreadcrumbItemComponent,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@tinct/web-components';
import { Link } from 'react-router-dom';

export type BreadcrumbItemConfig = {
  label: string;
  to?: string;
};

export function useBreadcrumb(items: BreadcrumbItemConfig[], endWithSeparator = false) {
  if (items.length === 0) return null;

  return (
    <Breadcrumb>
      <BreadcrumbList>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <div key={index} className="contents">
              <BreadcrumbItemComponent className={index === 0 ? 'hidden md:block' : ''}>
                {isLast && !item.to ? (
                  <BreadcrumbPage>{item.label}</BreadcrumbPage>
                ) : (
                  <BreadcrumbLink asChild>
                    <Link to={item.to || '#'}>{item.label}</Link>
                  </BreadcrumbLink>
                )}
              </BreadcrumbItemComponent>
              {(!isLast || endWithSeparator) && (
                <BreadcrumbSeparator className="hidden md:block" />
              )}
            </div>
          );
        })}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
